export default "__VITE_ASSET__f3da9908__"